export default __webpack_public_path__ + "static/Entenda0077-97ade771ac3db5c3e3fd4bac7142227d.jpg";